import { useMemo } from 'react'
import camelCase from 'lodash/camelCase'

import IconTitleGroup from 'common/components/iconTitleGroup'
import { useAppSelector } from 'common/hooks/redux'

import { getDetailsSectionFields } from './detailsSectionUtils'

const DetailsSection = () => {
  const typeOfIntegration = useAppSelector(
    (state) => state.campaignStates.typeOfIntegration
  )

  const campaign = useAppSelector((state) => state.campaignStates)

  const detailsSectionFields = useMemo(() => {
    const mergedData = {
      ...campaign.campaignData,
      typeOfIntegration,
    }
    return getDetailsSectionFields(mergedData).filter(
      (field) => field.value != null
    )
  }, [campaign, typeOfIntegration])

  return (
    <div aria-label="Details Information" data-testid="detailsSectionContainer">
      <IconTitleGroup title="Details" className="pb-8" />
      {detailsSectionFields.map(({ label, value }) => (
        <div
          className="flex my-0.25 w-full text-xs font-normal text-base-700"
          key={camelCase(label)}
          data-testid={`${camelCase(`${camelCase(label)}detailsSectionField`)}`}
        >
          <span className="w-2/5">{`${label}:`}</span>
          <span className="ml-4 w-3/5">{value}</span>
        </div>
      ))}
    </div>
  )
}

export default DetailsSection
